<template>
	<div class="newsList" ref="container">

		<!-- 头部 -->
		<div class="car-hear">
			<div class="car-het">
				<div style="float: left;">
					<img src="" alt="">
				</div>
				<p>{{$route.query.title}}</p>
			</div>
		</div>
		<!-- banner 广告图 -->
		<div class="list_ban">
			<img :src=banners alt="">
		</div>
		<!-- center  高亮栏-->
		
		<div class="list_tal"> 
			<div class="list-car">
				<span style="color: #d8334c;">最新公告</span>
			</div>
			<div class="list-cer">
				<ul :class="{marquee_top:animate}">
					<li v-for="i in tater">
						<span style="font-weight: bold;">{{i.title}}</span> 
					</li>
				</ul>
			</div> 
		</div>
		<!-- 页面主题内容 -->
		<div class="list-center">
			<router-link :to="{  path:'/news_detail/' + i.id ,query:{id:i.id, title:'了了'}}" v-for="i in getarts">
				<div class="list-center-max">
					<!-- {{getarts}} -->
					<div class="list-cen-img">
						<img :src=i.image_input alt="">
					</div>
					<div class="list-cen-tet">
						<h4 style="font-size: 17px; color: #4a4a4a;">{{i.title}}</h4>
						<p class="list-cen-tet-p">{{i.synopsis}}</p>
						<p style="float: right;color: #CCCCCC;">{{i.add_time}}</p>
					</div>
				</div>
			</router-link>
		</div> 
	</div>
</template>
<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "@assets/css/swiper.min.css";
	import {
		Tab,
		Tabs
	} from "vant";
	import {
		getArticleBanner,
		hotList,
		getArticleCategory,
		getArticleHotList,
		getArticleList
	} from "@api/public";
	import Loading from "@components/Loading";
	export default {
		name: "NewsList",
		components: {
			swiper,
			swiperSlide,
			Tab,
			Tabs,
			Loading
		},
		props: {},
		data: function() {
			
			return {
				getart: {
					cid: this.$route.query.id
				},
				banner: {
					id: this.$route.query.id
				},
				banners: '', 
				getarts: {},
				tater:{},
				animate: false,
			};
		}, 
		watch: {
		  $route(to) {
		     this.articleBanner();
			 this.articleHotList();
			 this.created()
		  }
		},
		mounted: function() {
			this.updateTitle() 
			this.articleBanner();
			this.articleHotList();
			// this.$scroll(this.$refs.container, () => {
			// 	!this.loading && this.getArticleLists();
			// });
		},
		created: function () { 
			setInterval (this.showMarquee, 2000) 
		},
		methods: {
			updateTitle() {
			  document.title = this.title || this.titles;
			},
			
			showMarquee: function () {
			    this.animate = true;  
				setTimeout (() => {
					this.tater.push (this.tater[ 0 ]);
					this.tater.shift ();
					this.animate = false;
				}, 500); 	
			},
 
			articleBanner: function() { 
				getArticleBanner({id: this.$route.query.id}).then(res => {
					this.banners = res.data.image_gg
				});
				 
				hotList({id: this.$route.query.id}).then(res => {
					this.tater = res.data
					console.log(res.data)
				}); 
			},
			articleHotList: function() { 
				getArticleHotList({cid: this.$route.query.id}).then(res => {
					this.getarts = res.data
				});
			},

		}
	};
</script>



<style>
	.newsList {
		background-color: #e7e7e7;
	}

	.car-hear {
		height: 55px;
		width: 100%;
		background-color: #FFF;
	}

	.car-het {
		height: 45px;
		width: 100%;
		background-color: #FFF;
		text-align: center;
		line-height: 50px;
		padding: 0 10px;
		box-shadow: 0 1px 5px 1px #dcdbda;
	}

	.car-hear p {
		font-size: 18px;
		font-weight: bold;
	}

	.list_ban {
		width: 100%;
		height: 4rem;
		background-color: #fff;
		margin-bottom: 12px;
		padding: 0 10px 10px;
	}

	.list_tal{
		width: 100%;
		padding:0 5%;
		height: 45px; 
		overflow: hidden;
		background-color: white;
		margin-bottom: 10px;;
	}

	.list-car{
		width: 30%;
		height: 45px;
		float: left;
		text-align: center;
		line-height: 45px; 
	}
	.list-cer {
		width: 70%;
		height: 45px;
		float: left;
		padding: 0 15px;
		background-color: #fff;
		line-height: 45px;
	}

	.marquee_top{
		transition: all 0.5s;
		margin-top: -45px
	}

	.list_ban img {
		width: 100%;
		height: 100%;
	}



	.list-center {
		width: 100%;
		height: auto;
		background-color: #fff;
	}

	.list-center-max {
		height: 100px;
		padding: 10px 0;
		border-bottom: 1px solid #d1d1d1;
	}

	.list-cen-img {
		width: 32%;
		height: 100%;
		float: left;
		margin: 0 15px;
	}

	.list-cen-img img {
		width: 100%;
		height: 100%;
	}

	.list-cen-tet {
		width: 100%;
		padding: 0 20px;
	}
	.list-cen-tet-p{
		font-size: 12px; 
		color: #CCCCCC;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
